import content_pic_list from './pic-list';
import content_pic_add from './pic-add';
import content_pic_edit from './pic-edit';
import content_pic_detail from './pic-detail';

export default {
    content_pic_list,
    content_pic_add,
    content_pic_edit,
    content_pic_detail,
};
